(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.getElementById('age-gate');
  if (!dialog) return;
  if (sessionStorage.getItem('age-verified') === '1') return;
  dialog.showModal();
  document.getElementById('age-gate-confirm').addEventListener('click', function () {
    sessionStorage.setItem('age-verified', '1');
    dialog.close();
  });
  document.getElementById('age-gate-deny').addEventListener('click', function () {
    dialog.close();
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;align-items:center;justify-content:center;height:100vh;background:#0a0a0a;color:#fff;font-family:sans-serif;text-align:center;padding:2rem;';
    var msg = document.createElement('p');
    msg.style.cssText = 'font-size:1.1rem;opacity:0.6;';
    msg.textContent = 'You must be 21 or older to access this site.';
    wrapper.appendChild(msg);
    document.body.replaceChildren(wrapper);
  });
});

  } catch(e) { console.error(e); }
})();
})();
